import axios from 'axios';
import { TokenUtils } from '@/utils/TokenUtils';

const baseUrl = `${process.env.VUE_APP_BASEURL}`;
const baseUrlCitCfdi = `${process.env.VUE_APP_BASEURL_CITCFDI}`;
const citCfdiApiKey = process.env.VUE_APP_CITCFDI_APIKEY;
const baseUrlAlmacen = process.env.VUE_APP_BASEURL_ALMACEN;

export default axios.create({
  baseURL: baseUrl,
  headers: { 'Content-Type': 'application/json' },
});

export const CitCfdiAxios = axios.create({
  baseURL: baseUrlCitCfdi,
  headers: { 'Content-Type': 'application/json', 'X-API-KEY': citCfdiApiKey },
});

export const AlmacenAxios = axios.create({
  baseURL: baseUrlAlmacen,
  headers: { 'Content-Type': 'application/json' },
});

const addAuth = (instance) => {
  instance.interceptors.request.use((config) => {
    const newConfig = config;
    const token = TokenUtils.getToken();
    if (token) {
      newConfig.headers.Authorization = `Bearer ${token}`;
    }
    return newConfig;
  });
};

addAuth(AlmacenAxios);

export function setAuthHeaders(headers) {
  return {
    ...headers,
    Authorization: `Bearer ${TokenUtils.getToken()}`,
  };
}
